<template>
<div class="container">
    <div class="common-header-wrap">
        <mt-header title="商家投诉" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
    </div>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div class="div"  v-if="complaintList && complaintList.length">
        	<div class="div complaint-item"  v-for="(item, index) in complaintList" :key="index">
        		<div class="head">
        			<div class="type">{{item.complain_subject_content}}</div>
        			<div class="time">{{ $moment.unix(item.complain_datetime).format('YYYY年MM月DD日') }}</div>
        		</div>
        		<div class="goods_info" @click="$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': item.order_goods_id } })">
        			<div class="image-wrapper">
        				<img class="img" :src="goodsList[item.order_goods_id].goods_image_url"/>
        			</div>
        			<div class="p-info">
        				<div class="goods_name">{{goodsList[item.order_goods_id].goods_name}}</div>
        				<div class="goods_price">￥{{goodsList[item.order_goods_id].goods_price}}</div>
        			</div>
        		</div>
        		<div class="div complaint-info">
        			<div class="complaint_content"><span>投诉内容：</span>{{item.complain_content}}</div>
        		</div>
        	    <div class="div complaint-btn">
        	        <div class="div btn-wrapper"><div class="div common-btn btn-1" v-if="item.complain_state=='10'" @click="cancelComplaint(item.complain_id)">取消</div></div>
        	        <div class="div btn-wrapper" v-if="item.complain_state==30">
        	            <div class="div common-btn btn-1" @click="handleComplain(item.complain_id)">提交仲裁</div>
        	        </div>
        	        <div class="div btn-wrapper"><div class="div common-btn btn-2" @click="goNavigate('/pages/member/complaint/ComplaintForm',{complain_id:item.complain_id})">查看</div></div>
        	    </div>
        	</div>
        </div>
        <empty-record v-else-if="complaintList && !complaintList.length"></empty-record>
    </div>
</div>
</template>

<script>
import { Indicator, MessageBox, Toast } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getComplaintList, cancelComplaint, handleComplain } from '../../../api/memberCompliant'
export default {
  name: 'BillList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      complaintList: false, // 商品列表
      goodsList: false
    }
  },
  methods: {
    handleComplain (complaint_id) {
      handleComplain(complaint_id).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    cancelComplaint (order_id) {
      MessageBox.confirm('你确定要取消吗？').then(action => {
        cancelComplaint(order_id).then(res => {
          Toast(res.message)
          this.$router.go(0)
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    getComplaintList (ispush) {
      Indicator.open()
      let params = this.params
      getComplaintList(params).then(res => {
        Indicator.close()
        if (res) {
          if (ispush && this.complaintList) {
            this.complaintList = this.complaintList.concat(res.result.complaint_list)
            this.goodsList = Object.assign(this.goodsList, res.result.goods_list)
          } else {
            this.complaintList = res.result.complaint_list
            this.goodsList = res.result.goods_list
          }
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getComplaintList(true)
      }
    }

  }
}
</script>

<style scoped lang="scss">
.complaint-item{
	background:#fff;
	border-bottom:1px solid #e1e1e1;
	margin-top: $modelSpace;
	border-radius: .5rem;
	padding: 0 $pageSpace;
	box-sizing: border-box;
	.head{
		padding: .3rem 0;
		display: flex;
		align-items: center;
		.type{
			font-size: .8rem;
			color: #333;
		}
		.time{
			font-size: .6rem;
			color: #999;
			margin-left: auto;
		}
	}
	.goods_info{
		display: flex;
		box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);
		.image-wrapper{
			width: 4rem;
			height: 4rem;
			flex: 0 0 4rem;
			border-radius: .5rem;
			overflow: hidden;
			img{
				width: 4rem;
				height: 4rem;
			}
		}
		.p-info{
			margin-left: .5rem;
			.goods_name{
				color: #333;
				font-size: .7rem; 
				line-height: .8rem;
				height: 1.6rem;
				margin-top: .4rem;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				padding: 0 .3rem;
				box-sizing: border-box;
			}
			.goods_price{
				color: $primaryColor;
				font-size: .8rem;
				margin-top: 1rem;
			}
		}
	}
	.complaint-info{
		padding: $modelSpace 0;
		.complaint_content{
			font-size: .7rem;
			color: #666;
			text{
				color: #333;
			}
		}
	}
	.complaint-btn{
		padding:.5rem;
		border-top:1px solid #e4e4e4;
		display: flex;
		justify-content: flex-end;
		.btn-1{border:1px solid $primaryColor;color:$primaryColor;min-width: 2rem}
		.btn-2{border:1px solid #333;color:#333;min-width: 2rem}
		.btn-wrapper{
			margin-left:.5rem
		}
		.buyer-info{
			flex:1;
			font-size:$subFontSize;
			line-height:1.4rem
		}
	}
}
</style>
